const configData =  {
    baseURL: 'https://app.priscilla.fitped.eu',
    jailSocketConnection: 'wss://demojail.dis.ulpgc.es/'
}

export default configData